import { useNavigate } from 'react-router-dom';
import SplashScreen from '../../components/SplashScreen/SplashScreen';

const Splash = () => {
  const navigate = useNavigate();

  const handleComplete = () => {
    navigate('/dashboard', { replace: true });
  };

  return <SplashScreen onComplete={handleComplete} />;
};

export default Splash;